import React from 'react';
import { isEditor } from '../../utils/isEditor.js';
import RefinanceCalculator from './RefinanceCalculator.js';
import { FieldConfig } from './RefinanceCalculator.utils.js';

var _attributes;
var RefinanceCalculatorBlock = {
  Component: function Component(_ref) {
    var attrs = _ref.attrs;
    var loanAmount = attrs.loanAmount,
      rate = attrs.rate,
      term = attrs.term,
      originationYear = attrs.originationYear,
      newLoanAmount = attrs.newLoanAmount,
      newTerm = attrs.newTerm,
      newRate = attrs.newRate,
      fees = attrs.fees,
      cashOut = attrs.cashOut,
      rollFees = attrs.rollFees;
    var defaultValues = {
      loanAmount: loanAmount,
      rate: rate,
      term: term,
      originationYear: originationYear,
      newLoanAmount: newLoanAmount,
      newTerm: newTerm,
      newRate: newRate,
      fees: fees,
      cashOut: cashOut,
      rollFees: rollFees
    };
    return /*#__PURE__*/React.createElement(RefinanceCalculator, {
      key: isEditor() ? JSON.stringify(defaultValues) : undefined,
      defaultValues: defaultValues
    });
  },
  metadata: {
    version: '1.0',
    name: 'constellation/refinance-calculator',
    title: 'Refinance calculator',
    description: 'Find out if refinancing makes sense for you.',
    icon: 'index-card',
    keywords: ['mortgages', 'calculators', 'refinance'],
    category: 'Calculators',
    supports: {
      customClassName: false,
      html: false
    },
    attributes: (_attributes = {}, _attributes[FieldConfig.loanAmount.name] = {
      type: 'number',
      default: 200000,
      label: 'Default loan amount',
      control: 'number'
    }, _attributes.rate = {
      type: 'number',
      default: 5,
      label: 'Default rate',
      control: 'number'
    }, _attributes.term = {
      type: 'number',
      default: 360,
      label: 'Default term',
      control: 'number'
    }, _attributes.newLoanAmount = {
      type: 'number',
      default: 195000,
      label: 'Default new loan amount',
      control: 'number'
    }, _attributes.newTerm = {
      type: 'number',
      default: 360,
      label: 'Default new term',
      control: 'number'
    }, _attributes.newRate = {
      type: 'number',
      default: 4.35,
      label: 'Default new rate',
      control: 'number'
    }, _attributes.fees = {
      type: 'number',
      default: 1000,
      label: 'Default fees',
      control: 'number'
    }, _attributes.cashOut = {
      type: 'number',
      default: 0,
      label: 'Default cash out',
      control: 'number'
    }, _attributes)
  }
};
var RefinanceCalculatorBlock$1 = RefinanceCalculatorBlock;

export { RefinanceCalculatorBlock$1 as default };
